// JS constants matching the breakpoints in breakpoints.scss

export const R720p = 1280;
export const R1080p = 1920;
